import React from 'react';
import ReactTooltip from 'react-tooltip';
import { useTypedSelector } from 'js/selectors/typedUseSelector';

import OptionMenuButton from './OptionMenuButton';
import { useAnimationStageContext } from './AnimationStageContext';
import './PenMenu.css';

const TOOLTIP_ID = 'pen-tooltip';
const PenMenu = () => {
  const { currentSelectedCursor, onCursorChoice } = useAnimationStageContext();
  const pens = useTypedSelector(state => state.cursors.penDraw);

  return (
    <>
      <div className="PenMenu">
        {pens.map(pen => {
          return (
            <OptionMenuButton
              key={pen.id}
              selected={pen.id === currentSelectedCursor}
              onClick={() => onCursorChoice(pen.id)}
              tooltipProps={{
                'data-tip': pen.name,
                'data-for': TOOLTIP_ID
              }}
            >
              <div className="PenMenu__buttonIcon" style={{ backgroundImage: `url(${pen.resources.thumbnail.url})` }} />
            </OptionMenuButton>
          );
        })}
      </div>

      <ReactTooltip id={TOOLTIP_ID} className="t-utility-label" />
    </>
  );
};

export default PenMenu;
